/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'confluence-table-tree.column.contributors': 'Bijdragers',
  'confluence-table-tree.column.last-modified': 'Laatst aangepast',
  'confluence-table-tree.column.title': 'Naam',
  'confluence-table-tree.could-not-load': 'Kon niet worden geladen',
  'confluence-table-tree.could-not-load-contributors': 'Bijdragers konden niet worden geladen',
  'confluence-table-tree.create-child-page': 'Maak een onderliggende pagina aan',
  'confluence-table-tree.create-page': 'Pagina aanmaken',
  'confluence-table-tree.default.page.title': 'Ongetiteld',
  'confluence-table-tree.default.show-all-pages-button.label': "Meer pagina's tonen",
  'confluence-table-tree.draft.lozenge': 'CONCEPT',
  'confluence-table-tree.draft.tooltip': 'Concepten zijn alleen zichtbaar voor jou.',
  'confluence-table-tree.drafts-toggle.label': 'Concepten weergeven',
  'confluence-table-tree.edit': 'Bewerken',
  'confluence-table-tree.edit-in-confluence': 'Bewerken in Confluence',
  'confluence-table-tree.empty.description':
    'Maak vergadernotulen, stel productvereisten op, neem beslissingen of maak andere content aan, om deze space op te vullen.',
  'confluence-table-tree.empty.title': 'Hier zijn alleen maar mogelijkheden',
  'confluence-table-tree.error.description': "We kunnen je deze pagina's niet laten zien. Probeer het later opnieuw.",
  'confluence-table-tree.error.row': "Kan pagina's niet laden.",
  'confluence-table-tree.error.title': 'Hmm, dit is niet zo handig...',
  'confluence-table-tree.friendly-when-created': 'Aangemaakt',
  'confluence-table-tree.friendly-when-updated': 'Bijgewerkt',
  'confluence-table-tree.share.copied': 'Gekopieerd naar klembord',
  'confluence-table-tree.share.copy-button': 'Kopiëren',
  'confluence-table-tree.share.subtitle': 'Deel deze link',
  'confluence-table-tree.share.title': 'Pagina delen',
  'confluence-table-tree.share.tooltip': 'Delen',
  'confluence-table-tree.view-profile': 'Profiel bekijken',
};
